import { render, staticRenderFns } from "./svg-template.vue?vue&type=template&id=d94d508e&scoped=true"
import script from "./svg-template.vue?vue&type=script&lang=js"
export * from "./svg-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94d508e",
  null
  
)

export default component.exports